var React = require('react');

function CloseIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M17.632 18.132L1.368 1.868m16.264 0L1.368 18.132","fill":"none","stroke":"#33454F","strokeDasharray":"24","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"2.5"}));
}

CloseIcon.defaultProps = {"width":"19","height":"20"};

module.exports = CloseIcon;

CloseIcon.default = CloseIcon;
